import React from 'react';
import PropTypes from 'prop-types';

import { clickAsLink } from 'helpers/link_helpers';
import { fetchCompany } from './api';
import { getItem } from 'helpers/session_storage_helper';

import PaginationButtons from '../../pagination_buttons';

const rootPath = '/contacts/companies';

const allCompaniesIds = getItem("contactsCompaniesIds", []);
export default class CompaniesPaginationButtons extends React.Component {
  static propTypes = {
    companyId: PropTypes.number.isRequired,
    currentIndex: PropTypes.number
  };

  state = {
    prevIndex: null,
    nextIndex: null
  }

  componentDidMount() {
    const { currentIndex } = this.props;

    if (currentIndex != null) {
      this.prevContact(currentIndex - 1);
      this.nextContact(currentIndex + 1);
    }
  }

  handleClick = (e, index) => {
    if (index  >= 0 && index < allCompaniesIds.length) {
      clickAsLink(window, `${rootPath}/${allCompaniesIds[index]}?offset=${index}`, e);
    }
  }

  nextContact = (nextIndex) => {
    if (nextIndex < allCompaniesIds.length && nextIndex != null)  {
      if (allCompaniesIds[nextIndex] === undefined) return;
      fetchCompany(allCompaniesIds[nextIndex]).then(() => {
        this.setState({ nextIndex: nextIndex });
      }).catch(() => {
        // this.nextContact(nextIndex++);
      });
    }
  }

  prevContact = (prevIndex) => {
    if (prevIndex >= 0 && prevIndex != null) {
      if (allCompaniesIds[prevIndex] === undefined) return;
      fetchCompany(allCompaniesIds[prevIndex]).then(() => {
        this.setState({ prevIndex: prevIndex });
      }).catch(() => {
        // this.prevContact(prevIndex--);
      });
    }
  }

  render() {
    const { currentIndex, companyId } = this.props;
    const { nextIndex, prevIndex } = this.state;

    if (currentIndex != null) {
      return (
        <PaginationButtons
          allIds={allCompaniesIds}
          currentIndex={currentIndex}
          entityId={companyId}
          nextIndex={nextIndex}
          prevIndex={prevIndex}
          onClick={this.handleClick}
        />
      );
    } else {
      return null;
    }
  }
}
